module.exports = __webpack_public_path__ + "img/4-6-2022_arakpacha.452b0372.jpeg";